<template>
  <b-modal
    :visible="showCloseModal"
    id="deleteJobModal"
    size="lg"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="closeModal"
  >
    <header class="d-flex align-items-center justify-content-between p-3">
      <div class="b-modal-header">
        {{
          type == "on-hold"
            ? "Move Job to On-Hold"
            : type == "delete"
            ? "Delete Job"
            : "Close Job"
        }}
      </div>
      <div class="rotate-on-hover pointer" @click="closeModal">
        <img
          v-b-tooltip.hover.top="'Close'"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt
        />
      </div>
    </header>
    <hr class="my-0" />
    <body class="px-4">
      <div class="mt-3 d-flex align-items-center">
        <img
          v-if="type == 'on-hold'"
          src="../../../assets/img/newworkbench/internalhiring/on-hold.svg"
          alt=""
        />
        <img
          v-else
          src="../../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
          alt=""
        />

        <div class="new-blck-font ml-3">
          {{
            type == "on-hold"
              ? "Would you like to move this job to on-hold?"
              : `Are you sure you want to ${type} this job?`
          }}
        </div>
      </div>
      <b-form-group class="new-center-radio d-flex flex-column mt-4">
        <div class="close-card d-flex align-items-center">
          <b-form-radio
            v-model="selectedOption"
            name="some-radios"
            value="auto"
          >
          </b-form-radio>
          <section>
            <strong class="close-text-head">Automatically Cancel</strong>
            <p class="close-text-body">
              This will automatically cancel the scheduled interview and
              {{
                type == "onhold"
                  ? "move the job to on-hold."
                  : `${type}
              the job.`
              }}
            </p>
          </section>
        </div>

        <div
          class="close-card d-flex align-items-center"
          :class="type == 'on-hold' ? 'mt-4' : 'my-4'"
        >
          <b-form-radio
            v-model="selectedOption"
            name="some-radios"
            value="manual"
          >
          </b-form-radio>
          <section>
            <strong class="close-text-head">Manually Cancel</strong>
            <p class="close-text-body">
              The scheduled interview must be cancelled manually before
              {{
                type == "on-hold"
                  ? "this job can be moved to on-hold."
                  : type == "delete"
                  ? "deleting this job."
                  : "closing this job."
              }}
            </p>
          </section>
        </div>
        <div
          v-if="type == 'on-hold'"
          class="close-card d-flex align-items-center my-4"
        >
          <b-form-radio
            v-model="selectedOption"
            name="some-radios"
            value="interview"
          >
          </b-form-radio>
          <section>
            <strong class="close-text-head">Let the Interview Go On</strong>
            <p class="close-text-body">
              The interview will proceed as scheduled, but the job will be
              on-hold for new candidates.
            </p>
          </section>
        </div>
      </b-form-group>
    </body>
    <hr />
    <footer
      class="d-flex align-items-center justify-content-end w-100 bluebtn pb-3"
    >
      <b-button class="acs-cancelBtn-modal mr-3" @click="closeModal"
        >Cancel</b-button
      >
      <b-button
        class="acs-addBtn-modal pl-4 pr-4 mr-3"
        :disabled="selectedOption == null"
        @click="goNext"
      >
        {{ type == "on-hold" ? "Continue" : "Next" }}
      </b-button>
    </footer>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import toast from "@/components/mixin/toast";

export default {
  data() {
    return {
      selectedOption: null,
      showDeleteModal: false,
    };
  },
  mixins: [toast],
  props: {
    showCloseModal: Boolean,
    fromOnHold: Boolean,
    type: String,
    fromCloseModal: Boolean,
    deleteData: Object,
  },
  created() {
    if (this.fromCloseModal) this.selectedOption = "auto";
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    goNext() {
      if (this.selectedOption === "manual") {
        if (this.roles.includes("GET_JOBDASHBOARD")) {
          this.$router.push({
            path: "/jdflow/kanban",
            query: {
              jobID: this.deleteData.jobID,
              customerID: this.deleteData.customerID,
              cardName:
                this.$route.params.cardName || this.$route.query.cardName,
            },
          });
        } else {
          this.errorModal("No permision to go to job dashboard");
          this.closeModal();
        }
      } else if (this.selectedOption === "auto") {
        if (this.type != "on-hold") {
          this.$emit("show-delete-modal");
        } else {
          this.$emit("move-to-on-hold", this.selectedOption);
        }
      } else if (this.selectedOption === "interview") {
        this.$emit("move-to-on-hold", this.selectedOption);
      }
    },
  },
};
</script>
<style scoped>
.close-text-body {
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}
.close-text-head {
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.close-card {
  gap: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 10px 15px 2px 15px;
}
</style>
